import React, { useState, useRef, useEffect} from "react";
import styles from './friendsPanel.module.css';
import { GrCircleInformation } from "react-icons/gr";
import { useGlobalState } from '../../global_state_components/GlobalStateProvider.jsx';
import Friends from "./Friends/Friends.jsx";
import BookMultipleSessions from "./BookMultipleSessions/BookMultipleSessions.jsx";


function FriendsPanel(){
  const [showFriends, setShowFriends] = useState(false);
  const [showBookMultipleSessions, setShowBookMultipleSessions] = useState(false);


  //------------------Handle clickoutside to close friends list-------------------
  const friendsExpansionRef = useRef(null);
  const friendsButtonRef = useRef(null);


  useEffect(() => {
    function handleClickOutside(event) {
      if (friendsExpansionRef.current && !friendsExpansionRef.current.contains(event.target) && !friendsButtonRef.current.contains(event.target)) {  //(if the reference element is active I guess) and (if the reference element is not clicked)
        // Clicked outside the component
        //console.log('Clicked outside!');
        setShowFriends(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);      //If click is given instead of mousedown it will negate the render done by clicking the "book with a friend" button.

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);   //If click is given instead of mousedown it will negate the render done by clicking the "book with a friend" button.
    };
  }, []);


    //------------------Handle clickoutside to close bookMultipleSessions-------------------
    const bookMultipleSessionsExpansionRef = useRef(null);
    const bookMultipleSessionsButtonRef = useRef(null);
  
  
    useEffect(() => {
      function handleClickOutside(event) {
        if (bookMultipleSessionsExpansionRef.current && !bookMultipleSessionsExpansionRef.current.contains(event.target) && bookMultipleSessionsButtonRef.current && !bookMultipleSessionsButtonRef.current.contains(event.target)) {  //(if the reference element is active I guess) and (if the reference element is not clicked)
          // Clicked outside the component
          //console.log('Clicked outside!');
          setShowBookMultipleSessions(false);
        }
      }
  
      document.addEventListener('mousedown', handleClickOutside);      //If click is given instead of mousedown it will negate the render done by clicking the "book with a friend" button.
  
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);   //If click is given instead of mousedown it will negate the render done by clicking the "book with a friend" button.
      };
    }, []);
  




  
  return(
    <div className={styles.category_selection_panel_div}>
      {(showFriends===true) && (<Friends friendsExpansionRef={friendsExpansionRef} setShowFriends={setShowFriends}/>)}
      <div name="friends" ref={friendsButtonRef} onClick={() => setShowFriends(prev=>!prev)} className={(showFriends===true)? styles.clicked_category : styles.category } >
        <p className={styles.category_title}>Friends</p>
      </div>
      
      {(showBookMultipleSessions===true) && (<BookMultipleSessions bookMultipleSessionsExpansionRef={bookMultipleSessionsExpansionRef} setShowBookMultipleSessions={setShowBookMultipleSessions}/>)}
      <div name="book_multiple_sessions" ref={bookMultipleSessionsButtonRef} onClick={() => setShowBookMultipleSessions(prev=>!prev)} className={(showBookMultipleSessions===true)? styles.clicked_category: styles.category} >
        <p className={styles.category_title}>Book multiple sessions</p>
      </div>
    </div>
  );
}

export default FriendsPanel;